import React from 'react';
import StatsBoxContainer from './stats-box.styles';

const StatsBox = ({ iconName, number, text }) => {
    return (
        <StatsBoxContainer>
            <i className={`${iconName}`}></i>
            <div className="number">{number}</div>
            <p>{text}</p>
        </StatsBoxContainer>
    );
};

export default StatsBox;
